import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import MemberActions from '../components/MemberActions';
import storage from '../../../../../lib/Storage';
import { loadCareGuideAdmin } from '../../../../../state/modules/careGuidesAdmin/actions';
import { loadCognitoFormsAdmin } from '../../../../../state/modules/cognitoFormsAdmin/actions';
import { findStorageType } from '../../../../../lib/Auth';

const defaultLimit = 20;
const defaultOrder = 'name';

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps.match.params;
  let partnershipId = storage.get(findStorageType(), 'partnershipId');

  const careGuide = state.entities.getIn(['careGuidesAdmin', id]);
  const profileId = state.session.get('profileId');
  const owner = {
    ...state.entities.getIn(['userProfiles', careGuide?.owner])?.profile,
  };

  const results = [].concat.apply(
    [],
    Object.entries(
      state.cognitoFormsAdmin.getIn(['pages', defaultOrder, defaultLimit], {})
    ).map(([k, v]) => v.toArray())
  );

  const list =
    results.length > 0
      ? results.map((x) => {
          return {
            key: x,
            ...denormalize(
              state.entities.getIn(['cognitoFormsAdmin', x]),
              schema.cognitoFormAdmin,
              state.entities.toJS()
            ),
          };
        })
      : [];

  return {
    careGuide,
    owner,
    careGuideId: id,
    partnershipId: partnershipId,
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    accessCareGuide: storage.get(findStorageType(), 'partnershipData')
      ?.access_role_admin_in_care_guide,
    accessTabsMembers: storage.get(findStorageType(), 'partnershipData')
      ?.access_role_admin_tabs_members,
    profileId,
    options: list,
    isLoading: state.cognitoFormsAdmin.get('isLoading'),
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partershipId, careguideId, cb) => {
      dispatch(loadCareGuideAdmin(partershipId, careguideId, cb));
    },
    loadTabs: (
      partnershipId,
      page = 1,
      limit = defaultLimit,
      order = defaultOrder,
      filter = { type: 2 },
      cb = function () {}
    ) => {
      dispatch(
        loadCognitoFormsAdmin(
          partnershipId,
          page,
          limit,
          order,
          filter,
          (success, total) => {
            if (success) {
              // loop over all pages to get all events
              const pageCount = Math.ceil(total / limit);
              for (var i = 2; i <= pageCount; i++) {
                dispatch(loadCognitoFormsAdmin(partnershipId, i, limit, order));
              }
              cb();
            }
          }
        )
      );
    },
  };
};

const MemberActionsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MemberActions);

export default MemberActionsContainer;
